import {
  type CSSProperties,
  type MouseEvent,
  PropsWithChildren,
  useRef,
  useState,
} from 'react';
import type { FolderStruct, RenderTrailingProp } from '../types';

export const FolderWithTrailing = <T,>({
  folderStructure,
  onClick,
  renderTrailing,
  children,
  maxWidth,
  isSelected,
  isExpanded,
}: PropsWithChildren<{
  folderStructure: FolderStruct<T>;
  onClick: (e: MouseEvent<HTMLDivElement>) => void;
  renderTrailing?: RenderTrailingProp<T>;
  maxWidth?: number | string;
  isSelected: boolean;
  isExpanded: boolean;
}>) => {
  const [isHovered, setIsHovered] = useState(false);

  const folderRef = useRef<HTMLDivElement>(null);

  return (
    <div
      ref={folderRef}
      className="relative flex items-center bg-background-white hover:bg-background-hover pr-[15px] w-full max-w-[var(--maxWidth)] min-w-[160px] cursor-pointer"
      style={
        {
          '--maxWidth':
            typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,
        } as CSSProperties
      }
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      data-qa-folder-id={folderStructure.id}
    >
      {children}
      {renderTrailing?.({
        folderRef,
        folderStructure,
        isHovered,
        isSelected,
        isExpanded,
        setIsHovered,
      })}
    </div>
  );
};
